import { prototypeFunnel, type BuilderTree } from '@nsb/core';
import { useMemo } from 'react';
import { PriceFunnel } from '../PriceFunnel.tsx';
import { prototypeSentence } from '../funnelSentence.ts';

/**
 * The prototypical funnel (Jason, 2026-10-04: "at the top of the process tree design page i want to see the
 * prototypical funnel build in real time as I define the tree and the dependencies"), built the way a job's is (L-12;
 * Jason, 2026-10-07: "make sure this funnel is built the same way the real funnel is but you can use the percentages of
 * 100% for the phases, and the confidence levels as shown"): the draft's phases put through the funnel's own core
 * (`prototypeFunnel`, through `buildFunnel`) and drawn by the funnel a project's home draws (`PriceFunnel`), its time a
 * job's laid out by the phases' shares and its band how sure the price is as each phase closes, in ±%. The sentence
 * first, then the drawing (guide §20.1).
 */
export function PrototypeFunnel({ tree }: { tree: Pick<BuilderTree, 'phases' | 'startSpread' | 'nodes'> }) {
  const funnel = useMemo(() => prototypeFunnel(tree), [tree]);
  return (
    <figure>
      <p className="mb-3 max-w-measure text-ink-2">{prototypeSentence(funnel)}</p>
      <PriceFunnel funnel={funnel} staff />
    </figure>
  );
}
